import { AppConfigService } from "./app.config.service";
import { ErrorHandler } from "./error.handler.service";

import { CommonService } from "./common.service";
import { IHeartbeatMonitor } from "./heartbeat/interfaces";
import {
  GenesysWebChatHeartbeatMonitor,
  GenesysWebMessagingHeartbeatMonitor,
  NoHeartbeatMonitor,
} from "./heartbeat";
import { IConversation } from "@auvious/integrations";

class HeartbeatServiceCtrl {
  private _instance: IHeartbeatMonitor;
  private _interval;

  private init() {
    switch (AppConfigService.chatMode) {
      case "genesys-api":
      case "genesys-cloud":
      case "genesys-premise":
        this._instance = new GenesysWebChatHeartbeatMonitor();
        break;
      case "genesys-web-messaging":
        this._instance = new GenesysWebMessagingHeartbeatMonitor();
        break;
      // add more in the future
      default:
        this._instance = new NoHeartbeatMonitor();
        break;
    }
  }

  /**
   * starts a keep-alive monitor in auvious and beats every X seconds.
   * If beat fails, it retries 3 times and then stops the interval
   *
   * @param interactionId
   * @param jwt
   * @param memberId
   * @param timeoutSeconds
   */
  public async createMonitor(
    conveersation: IConversation,
    timeoutSeconds: number
  ): Promise<void> {
    if (!this._instance) {
      this.init();
    }

    let retries = 0;
    ErrorHandler.addBreadcrumb("Heartbeat | create monitor");
    await this._instance.createMonitor(conveersation, timeoutSeconds);

    if (this._interval) {
      CommonService.timer.clearInterval(this._interval);
      this._interval = null;
    }

    this._interval = CommonService.timer.setInterval(async () => {
      try {
        await this.beat();
      } catch (ex) {
        if (retries > 2) {
          CommonService.timer.clearInterval(this._interval);
          this._interval = null;
          retries = 0;
        }
        retries += 1;
      }
    }, timeoutSeconds * 0.75 * 1000);
  }

  public destroyMonitor() {
    if (this._interval) {
      ErrorHandler.addBreadcrumb("Heartbeat | destroy monitor");
      CommonService.timer.clearInterval(this._interval);
      this._interval = null;
      return this._instance?.destroyMonitor();
    }
  }

  public cleanup() {
    this._instance?.cleanup();
  }

  private beat() {
    return this._instance?.beat();
  }
}

export const HeartbeatService = new HeartbeatServiceCtrl();
